import epgRequest from '~/src/api/requests/epgRequest';
import contentRequest from '~/src/api/requests/contentRequest';
import { REQUEST_TIMEOUT } from '../../constants';

export function getBanner(cityId) {
    return contentRequest.getWithCache(`v1/cities/${cityId}/promo`, {
        timeout: REQUEST_TIMEOUT,
    });
}

export function getTariffs(cityId, isAuth = false, additionalParams) {
    return contentRequest.getWithCache(`v1/cities/${cityId}/sales?${isAuth ? 'availableAuth=1' : 'availableNew=1'}${additionalParams ? additionalParams : ''}`, {
        timeout: REQUEST_TIMEOUT,
    });
}

export function getTariffsAll(cityId, isAuth = false, isSelfOrder = false) {
    return contentRequest.getWithCache(
        `v1/cities/${cityId}/tariffs?` +
        `${isAuth ? 'availableAuth=1' : 'availableNew=1'}` +
        `${isSelfOrder ? '&selfOrder=1' : ''}`,
        {
            timeout: REQUEST_TIMEOUT,
        }
    );
}

export const prepareTariffsZasmotris = (bundles) => {
    return Object.values(bundles).filter(tariff => {
        const alias = tariff?.description?.alias;
        return alias === 'zasmotris' || alias === 'zasmotris-light';
    });
};

export function getChannelThemes() {
    return epgRequest.getWithCache('/channeltheme/list');
}

export function getAllChannels(citydomain, bid = null) {
    const params = {
        domain: citydomain,
        t: Date.now,
    };
    if (bid) {
        params.bid = bid;
    }
    return epgRequest.getWithCache('/geobundle/channels?', { params: params });
}

export function getTvPacketList(isActive = 1) {
    return epgRequest.getWithCache(`/tv-packet/list${isActive ? '?isActive=1' : ''}`);
}

export function getTvPacketInfo(bid, domain) {
    return epgRequest.getWithCache(`/tv-packet/info?bid=${bid}&domain=${domain}`);
}

export function getPacketChannelsList(domain, params = null, bids = null) {
    const options = {
        domain,
    };
    if (bids) {
        options.bids = bids;
    }
    if (params) {
        options.params = params;
    }
    return epgRequest.getWithCache('/tv-packet-channel/list', { params: options });
}
